import { EditUserComponent } from './../../User_Manage/Edit User/EditUser/EditUser.component';
import { UserTemplatesComponent } from './../../TemplatesManage/UserTemplates/UserTemplates.component';
import { DataTablesModule } from 'angular-datatables';
import { MigrationComponent } from './../../Migration/Migration/Migration.component';
import { AddUserComponent } from './../../User_Manage/AddUser/AddUser/AddUser.component';
import { Device_ManageComponent } from './../../Device_Manage/Device_Manage.component';
import { RealTime_Enroll_ViewComponent } from './../../Real-Time_Enroll_View/Real-Time_Enroll_View.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { HomeComponent } from 'src/app/Home/Home.component';
import { User_ManageComponent } from 'src/app/User_Manage/User_Manage.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { RealTIme_LogViewComponent } from 'src/app/RealTIme_LogView/RealTIme_LogView.component';
import { FormsModule } from '@angular/forms';
import { Log_ManageComponent } from 'src/app/Log_Manage/Log_Manage.component';
import { GenerateTextFileComponent } from 'src/app/GenrateTextFile/GenerateTextFile/GenerateTextFile.component';
import { Import_FileComponent } from 'src/app/Import File/Import_File/Import_File.component';
import { NgxSpinnerModule } from 'ngx-spinner';



@NgModule({
  declarations: [
    DefaultComponent,
    HomeComponent,
    User_ManageComponent,
    RealTIme_LogViewComponent,
    RealTime_Enroll_ViewComponent,
    Device_ManageComponent,
    AddUserComponent,
    EditUserComponent,
    MigrationComponent,
    Log_ManageComponent,
    UserTemplatesComponent,
    GenerateTextFileComponent,
    Import_FileComponent


  ],
  imports: [
    FormsModule,
    DataTablesModule,
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    NgxSpinnerModule,
  ]

})
export class DefaultModule { }
